import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=a8c3b91c&scoped=true&lang=pug"
import script from "./Draft.vue?vue&type=script&lang=js"
export * from "./Draft.vue?vue&type=script&lang=js"
import style0 from "./Draft.vue?vue&type=style&index=0&id=a8c3b91c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3b91c",
  null
  
)

export default component.exports